<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 16 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M9.81 4.83 10 1.69 14 1.69 14.19 4.83 17.12 6.51 19.92 5.11 21.93 8.58 19.31 10.31 19.31 13.69 21.93 15.42 19.92 18.89 17.12 17.49 14.19 19.17 14 22.31 10 22.31 9.81 19.17 6.88 17.49 4.08 18.89 2.07 15.42 4.69 13.69 4.69 10.31 2.07 8.58 4.08 5.11 6.88 6.51z"
    />
    <circle cx="12" cy="12" r="3" />
  </svg>
</template>
